import React, { useEffect, useState } from "react";
import {
  AdminNavigation,
  Title,
  Input,
  Button,
  Select,
  Modal,
} from "../../../components";
// import styles from "./styles.module.css";
import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useToast, CircularProgress, Center } from "@chakra-ui/react";
import { FaWrench, FaTrashAlt } from "react-icons/fa";
import {
  addNewAdmin,
  editAdmin,
  getAllAdmin,
  getAllRoles,
  removeAdmin,
} from "../../../redux/actions/admin/authActions";
import {
  CREATE_ADMIN_RESET,
  DELETE_ADMIN_RESET,
  UPDATE_ADMIN_RESET,
} from "../../../redux/constants/admin/authConstants";

const Admin = () => {
  const ptitle = "Admin";
  const dispatch = useDispatch();
  const toast = useToast();
  //   const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [email, setEmail] = useState("");
  const [roleId, setRoleId] = useState("");
  const [id, setID] = useState(null);

  useEffect(() => {
    dispatch(getAllAdmin());
    dispatch(getAllRoles());
  }, [dispatch]);

  const openHandler = () => {
    setOpen(true);
    setEdit(false);
    setEmail("");
    setRoleId("");
  };

  const createAdmin = useSelector((state) => state.createAdmin);
  const { loading, error, success } = createAdmin;

  const deleteAdmin = useSelector((state) => state.deleteAdmin);
  const { dLoading, dError, dSuccess } = deleteAdmin;

  const getRoles = useSelector((state) => state.getRoles);
  const { roles } = getRoles;

  const updateAdmin = useSelector((state) => state.updateAdmin);
  const { uLoading, uError, uSuccess } = updateAdmin;

  const getAdmins = useSelector((state) => state.getAdmins);
  const { admins } = getAdmins;
  const columns = [
    { title: "Email", field: "email" },
    { title: "Role", field: "roleName" },
  ];

  const deleteHandler = (id) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete this ${ptitle}`,
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(removeAdmin(id));
      }
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!email || !roleId) {
      toast({
        title: "Warning!",
        description: "All Fields are Required",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(addNewAdmin(email, roleId));
    }
  };

  const editHandler = (e) => {
    e.preventDefault();
    if (!email || !roleId) {
      toast({
        title: "Warning!",
        description: "All Fields are Required",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(editAdmin(email, roleId, id));
    }
  };

  if (error || uError || dError) {
    toast({
      title: "Error",
      description: error || uError || dError,
      status: "error",
      duration: 9000,
      isClosable: true,
    });
    error && dispatch({ type: CREATE_ADMIN_RESET });
    uError && dispatch({ type: UPDATE_ADMIN_RESET });
    dError && dispatch({ type: DELETE_ADMIN_RESET });
  }

  if (success || uSuccess || dSuccess) {
    toast({
      title: "Notification",
      description: `Sucesss`,
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    setOpen(false);
    dispatch(getAllAdmin());
    success && dispatch({ type: CREATE_ADMIN_RESET });
    uSuccess && dispatch({ type: UPDATE_ADMIN_RESET });
    dSuccess && dispatch({ type: DELETE_ADMIN_RESET });
  }
  return (
    <div className="appContainer">
      <AdminNavigation />
      <div className="contentsRight">
        <Title title="Admin" type="Admin" />
        <div className="btnContainer right">
          <button type="button" onClick={openHandler} className="btn teal">
            Add {ptitle}
          </button>
        </div>
        {dLoading ? (
          <Center>
            <CircularProgress isIndeterminate color="#3AB29A" />
          </Center>
        ) : (
          <MaterialTable
            title=""
            columns={columns}
            data={admins}
            options={{
              exportAllData: true,
              exportButton: true,
              actionsCellStyle: {
                backgroundColor: "none",
                color: "#FF00dd",
              },
              actionsColumnIndex: -1,

              headerStyle: {
                backgroundColor: "#dcdcdc",
                color: "black",
                fontWeight: "bold",
              },
            }}
            style={{
              boxShadow: "none",
              width: "100%",
              background: "none",
              fontSize: "13px",
            }}
            actions={[
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Update",
                onClick: (event, rowData) => {
                  setOpen(true);
                  setEdit(true);
                  setEmail(rowData.email);
                  setRoleId(rowData.roleId);
                  setID(rowData.id);
                },
                title: "Update",
                color: "teal",
                Icon: FaWrench,
              },
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  deleteHandler(rowData._id);
                },
                title: "Delete",
                color: "gold",
                Icon: FaTrashAlt,
              },
            ]}
            components={{
              Action: (props) => (
                <button
                  onClick={(event) => props.action.onClick(event, props.data)}
                  className={`btnTable ${props.action.color}`}
                >
                  <props.action.Icon />
                  {props.action.title}
                </button>
              ),
            }}
          />
        )}
        <Modal
          isVisible={open}
          title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
          size="lg"
          content={
            <form onSubmit={edit ? editHandler : submitHandler}>
              <div className="nirsal__InputFlex">
                <Input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  required={true}
                  title="Email"
                  size="large"
                />
                <Select
                  onChange={(e) => setRoleId(e.target.value)}
                  value={roleId}
                  title="Role"
                  options={roles}
                  filter="name"
                  filterValue="id"
                  size="large"
                />

                {/* <Select
                  onChange={(e) => setCountry(e.target.value)}
                  value={country}
                  title="Country"
                  data={Options.countries}
                  size="large"
                /> */}

                <Button
                  title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
                  type="submit"
                  isFullWidth={true}
                  size="lg"
                  loading={loading || uLoading}
                />
              </div>
            </form>
          }
          onClose={() => setOpen(false)}
        />
      </div>
    </div>
  );
};

export default Admin;
